import './group-description.css';
import { h } from 'preact';

/**
 * When children is a string or an array with one string then ** (markdown) will be strong
 */
export default function GroupDescription({ children }) {
	const [firstChild] = Array.isArray(children) ? children : [children];
	return (
		<div className="group-description-container">
			{(!Array.isArray(children) || children.length === 1) && typeof firstChild === 'string' ? firstChild.split('**').map((words, index) => index % 2 === 1 ? <strong>{words}</strong> : words) : children}
		</div>
	);
}
